import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';


import {HttpClient, HttpHeaders} from '@angular/common/http';
import { JobOffer } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class CurriculaService {

  constructor(private http: HttpClient) {
  }


  getCurriculum(applier_id: number, event_id: any): Observable<JobOffer> {
    let queryParams = '?language=it';
    if (event_id) {
      queryParams += '&event_id=' + event_id;
    }
    return this.http.get<JobOffer>(
      environment.baseUrlWs + environment.wsVerison + 'employer/user/' + applier_id + '/' + queryParams
    );
  }


  // employer/jobs/get-applications/?candidates_id=330217
  getApplications(applier_id: number, job_id: any = false): Observable<any> {
    let queryParams = '';
    if (job_id) {
      queryParams = '?jobs_id=' + job_id;
    }
    return this.http.get<any>(
      environment.baseUrlWs + 'v2/employer/jobs/get-applications/' + applier_id + '/' + queryParams
    );
  }

  getCheckIns(users_id: number): Observable<any> {
    const queryParams = '?users_id=' + users_id;
    return this.http.get<any>(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/get-check-ins/' + users_id
    );
  }

  saveApplicationComment(application: object) {
    return this.http.put(
      environment.baseUrlWs + environment.wsVerison + 'employer/jobs/' + application['applications_id'] + '/curriculum-save-comment',
      {comment: application['comments']}
    )
  }

  saveCheckInComment(checkIn: object) {
    return this.http.put(
      environment.baseUrlWs + environment.wsVerison + 'employer/events/' + checkIn['events_id'] + '/add-comment-to-user',
      {
        comments: checkIn['comments'],
        users_id: checkIn['users_id']
      }
    )
  }

  //////////
  getCurriculaPage(applicationId: number | string, page: number = 0): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/${applicationId}/pages/${page}`;
    return this.http.get(url, { observe: 'response', responseType: 'arraybuffer' as 'json' });
  }

  getCurriculaPdf(applicationId: number | string): Observable<any> {
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/curricula/${applicationId}/cv`;
    return this.http.get(url, { observe: 'response', responseType: 'arraybuffer' as 'json' });
  }

  putApplicationComment(applicationId: number, comment: string): Observable<any>{
    const url = `${environment.baseUrlWs}${environment.wsVerison}employer/jobs/${applicationId}/curriculum-save-comment`;
    return this.http.put(url, {comment: comment});
  }
}
